<template>
    <div class="www pt-4 pb-2 select-none">
        <label
            for="i-height"
            class="block text-sm font-medium text-gray-700"
        >
            {{ t('templateContentHeight') }}
        </label>
        <input
            :id="`i-height`"
            v-model="members.height"
            type="text"
            :name="`i-height`"
            autocomplete="off"
            class="mt-1 block w-full rounded-md border border-gray-300 px-2 py-1 text-sm shadow-sm focus:border-blue-500 focus:ring-blue-500 focus:outline-hidden"
            :disabled="!stateRepository.states.size"
        />
    </div>
</template>

<script setup>
    import { t } from '../composables/i18n';

    defineExpose({
        name: 'SizeWidget',
    });

    const props = defineProps({
        members: {
            type: Object,
            default: () => {
                return {};
            },
        },
        stateRepository: {
            type: Object,
            required: true,
        },
    });

    const stateRepository = props.stateRepository;

    const members = props.members;
</script>
